import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import { DropdownItem } from 'components/Dropdown'
import StateDropdown from 'components/Dropdown/StateDropdown'
import Heading from 'components/Heading'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'

interface FAQProps {
  size?: Size
  nrItems?: number
  className?: string
}

const FAQ: React.FC<FAQProps> = props => {
  const renderItems = () => {
    const length = props.nrItems || 4
    const output = []
    for (let i = 1; i <= length; i++) {
      output.push(
        <DropdownItem
          key={i}
          label={
            <DisplayContent addNode contentKey={`${i}-dropdown-heading`}>
              Unlimited freedom to customise your city trip ?
            </DisplayContent>
          }
        >
          <div>
            <DisplayContent contentKey={`${i}-dropdown-text`}>
              First determine when, with whom and for how long you want to be
              away. Do you want to go for 3, 4 or 5 days or would you much
              rather go for an entire week? In addition to this, you also have
              to figure out in what type of accommodation you would like to
              stay, what time you would prefer to depart from what airport and
              roughly where in the world you would like to be surprised. Adding
              a transfer, breakfast, extra suitcase or a baby bed to your trip,
              is optional too.
            </DisplayContent>
          </div>
        </DropdownItem>,
      )
    }
    return output
  }

  return (
    <Section
      type={SectionType.white}
      size={props.size || Size.s}
      className={props.className}
    >
      <Heading level={3}>
        <DisplayContent contentKey="faq">FAQ</DisplayContent>
      </Heading>
      <StateDropdown name="TABA">{renderItems()}</StateDropdown>
    </Section>
  )
}

export default FAQ
